// extracted by mini-css-extract-plugin
export default {"zoomModal":"Y1-z","image":"Z1-z","button":"_1-z","isOverlayShown":"a2-z"};